<p-dialog
  [modal]=true
  appendTo="body"
  [blockScroll]="true"
  [(visible)]="visible"
  [responsive]="true"
  [style]="{width: '40vw'}"
  (onHide)="onHideImport()">
  <ng-template pTemplate="header">
    
    {{ headerTitle | translate }}
  
  </ng-template>

  

  <form
    #importform="ngForm"
    class="form-horizontal"
    (ngSubmit)="onSaveImport();">

    <!-- Type -->
    <div class="form-group">
      <label class="control-label col-sm-12">
        {{ 'File Type' | translate }}:
      </label>
      <div class="col-sm-12">
        <select
            (change)="onSelectImportType($event)"
            class="form-control"
            name="file_type"
            [required]="requiredType">
            <option [value]="null"> -- </option>
            <option
                *ngFor="let type of fileTypesList"
                [value]="type.value">
                {{ type.text | translate }}
            </option>
        </select>
      </div>
    </div>

    <br/>

    <!-- File -->
    <div class="form-group">
      <label class="control-label col-sm-12">
        {{ 'File' | translate }}:
      </label>
      <div class="col-sm-12">
        <label type="button" [class.btn-disabled]="disableImportFile() || !currentFileType" for="files" class="btn secundary-btn  me-2">
          <i class="fa fa-paperclip fa-fw">
          </i>{{ 'Choose File' | translate }}</label>
        <input
          id="files"
          style="visibility:hidden;"
          #attachmentFile
          type="file"
          class="btn btn-default btn-file"
          (change)="onSelectImportFile($event)"
          [accept]="acceptedTypes"
          [disabled]="disableImportFile() || !currentFileType"
          required>
          <!-- multiple -->
        <label
          *ngIf="uploadDisabled" class="control-label" style="color:red">
          {{ 'Please select file smaller than 25MB' | translate }}
        </label>
      </div>
    </div>

    <br>

    <div class="form-group">
      <div class="col-sm-12">
        <table
          *ngIf="filesToImport && filesToImport.length > 0"
          class="table table-condensed table-hover"
          style="width:100%;">
          <caption>File types</caption>
          <thead style="background:#f9f9f9">
            <tr>
              <th scope="col">{{ 'Name' | translate }}</th>
              <th scope="col">{{ 'Type' | translate }}</th>
              <th *ngIf="!disabled" scope="col"></th>
              <!-- <th></th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let fileToImport of filesToImport; let i = index">
              <td [style.color]="this.getStatusColor(fileToImport?.status)" *ngIf="fileTypes[fileToImport?.attachment_type]">
                {{
                  fileToImport?.file ?
                  fileToImport.file.name : fileToImport.name
                }}
              </td>
              <td  [style.color]="this.getStatusColor(fileToImport?.status)" *ngIf="fileTypes[fileToImport?.attachment_type]">
                {{
                  fileTypes[fileToImport?.attachment_type] | translate
                }}
              </td>
              <td *ngIf="!disabled && fileTypes[fileToImport?.attachment_type]">
                <i
                  (click)="onRemoveImportFileRequest(i)"
                  class="fa fa-trash like-link">
                </i>
              </td>
              <!-- <td></td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <br>

    <div class="footer-btns">
        <button
          type="button"
          style="margin-right: 10px;"
          class="btn secundary-btn secundary-btn-fw"
          (click)="onCancelImport()">
          {{ 'Cancel' | translate }}
        </button>
        <button
          type="submit"
          class="btn primary-btn primary-btn-fw"
          [disabled]="importform.form.invalid || uploadDisabled">
          {{ 'Save' | translate }}
        </button>
    </div>

  </form>
</p-dialog>

<div>
  <table
    *ngIf="filesToImport && filesToImport.length > 0"
    class="table table-condensed table-hover"
    style="width:100%;">
    <caption>File types</caption>
    <thead style="background:#f9f9f9">
      <tr>
        <th scope="col">{{ 'Name' | translate }}</th>
        <th scope="col">{{ 'Type' | translate }}</th>
        <th scope="col" *ngIf="fileSubTypes">{{ 'Subtype' | translate }}</th>
        <th scope="col" *ngIf="!disabled"></th>
        <!-- <th></th> -->
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let fileToImport of filesToImport; let i = index">
        <td *ngIf="fileTypes[fileToImport?.attachment_type]">
            <a 
              (click)="showPreviewAttachment(fileToImport)"
              style="cursor: pointer; color: black"
              [style.color]="this.getStatusColor(fileToImport?.status)">
              {{
                fileToImport?.file ?
                fileToImport.file.name : fileToImport.name
              }}
            </a>
        </td>
        <td *ngIf="fileTypes[fileToImport?.attachment_type]"
          [style.color]="this.getStatusColor(fileToImport?.status)">
          {{
            fileTypes[fileToImport?.attachment_type] | translate
          }}
        </td>
        <td *ngIf="fileSubTypes && fileTypes[fileToImport?.attachment_type]" [style.color]="this.getStatusColor(fileToImport?.status)">
          {{
            fileSubTypes[fileToImport?.attachment_subtype] | translate
          }}
        </td>
        <td *ngIf="!disabled && fileTypes[fileToImport?.attachment_type]">
          <i
            *ngIf="!uploading || !disabled"
            (click)="onRemoveImportFileRequest(i)"
            class="fa fa-trash like-link">
          </i>
        </td>
        <!-- <td></td> -->
      </tr>
      <tr *ngIf="!disabled">
        <td>
          <button
            [disabled]="disabled"
            [hidden] = "disabled"
            style="float:left;"
            type="button"
            class="btn secundary-btn-green"
            (click)="onStartImport()">
            <i class="fa fa-plus fa-fw"></i>
            {{ 'Import File' | translate }}
          </button>
        </td>
        <td></td>
        <td></td>
        <td *ngIf="!disabled"></td>
      </tr>
    </tbody>
  </table>
  <button
    *ngIf="filesToImport && filesToImport.length === 0"
    [disabled]="disabled || serviceSapError"
    [hidden] = "disabled"
    type="button"
    class="btn secundary-btn-green"
    (click)="onStartImport()">
    <i class="fa fa-plus fa-fw"></i>
    {{ '0 Imported Files' | translate }}
  </button>
</div>

<p-dialog
  appendTo="body"
  [(visible)]="showPreviewDialog"
  [responsive]="true"
  [modal]="true"
  [draggable]="false"
  [breakpoint]="500"
  [blockScroll]="true"
  [style]="{width: '40vw'}"
  [class.ui-dialog-titlebar]="true">
  <ng-template pTemplate="header">
    
    {{ 'Download Attachment' | translate }}
  
  </ng-template>

  

  <app-attachment-preview
    [setAttachment]="setAttachment"
    (cancelEvent)="closePreviewAttachment()"
    (download)="closePreviewAttachment()"
    #downloadForm>
  </app-attachment-preview>
</p-dialog>

